import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import EmailIcon from "@mui/icons-material/Email";
import PhoneIcon from "@mui/icons-material/Phone";
import { Avatar, Box, Chip, Grid, Stack, Typography } from "@mui/material";
import { IMAGE_URL } from "config";
import { useDenominationStore } from "features/denominations";
import { useSearchParams } from "react-router-dom";
import { getEthiopianDateWithMonthNames } from "utils/getEthiopianDateWithMonthNames";

export const DenominationSummaryHeader = () => {
  const selectedDenomination = useDenominationStore(
    state => state.selectedDenomination
  );

  const [searchParams] = useSearchParams();

  const startDate = searchParams.get("startDate");
  const endDate = searchParams.get("endDate");

  return (
    <Stack
      sx={{
        background: "linear-gradient(to right, #00B0B9, #008087, #00B0B9)",
        color: "white",
        p: 3,
        borderRadius: 2
      }}
    >
      <Grid container spacing={2}>
        <Grid item xs={12} sx={{ textAlign: "center", mb: 2 }}>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="center"
            spacing={3}
          >
            <Avatar
              src={`${IMAGE_URL}/${selectedDenomination?.image_url}`}
              alt={selectedDenomination?.name}
              sx={{
                border: "2px solid",
                borderColor: "primary.main",
                width: 100,
                height: 100
              }}
            />
            <Stack spacing={1}>
              <Typography variant="h6" sx={{ mt: 1, fontWeight: 500 }}>
                {selectedDenomination?.name}
              </Typography>
              <Typography variant="subtitle1">አጠቃላይ ሪፖርት</Typography>
              <Stack
                direction="row"
                alignItems="center"
                spacing={1}
                flexWrap="wrap"
              >
                <Chip
                  label={
                    startDate
                      ? getEthiopianDateWithMonthNames(startDate, "short")
                      : ""
                  }
                  size="small"
                  sx={{
                    backgroundColor: "rgba(255, 255, 255, 0.2)",
                    color: "#fff",
                    fontWeight: 600,
                    fontSize: "0.75rem",
                    "& .MuiChip-label": {
                      px: 1.5
                    }
                  }}
                />
                <Typography
                  variant="body2"
                  sx={{ opacity: 0.8, fontWeight: 500 }}
                >
                  to
                </Typography>
                <Chip
                  label={
                    endDate
                      ? getEthiopianDateWithMonthNames(endDate, "short")
                      : ""
                  }
                  size="small"
                  sx={{
                    backgroundColor: "rgba(255, 255, 255, 0.2)",
                    color: "#fff",
                    fontWeight: 600,
                    fontSize: "0.75rem",
                    "& .MuiChip-label": {
                      px: 1.5
                    }
                  }}
                />
              </Stack>
            </Stack>
          </Stack>
        </Grid>

        <Grid item xs={12}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              flexWrap: "wrap",
              gap: 2
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <PhoneIcon fontSize="small" />
              <Typography>ስልክ: {selectedDenomination?.phone}</Typography>
            </Box>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <EmailIcon fontSize="small" />
              <Typography>
                ፖስት ሳጥን ቁጥር: {selectedDenomination?.p_o_box}
              </Typography>
            </Box>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <EmailIcon fontSize="small" />
              <Typography>ኢሜል: {selectedDenomination?.email}</Typography>
            </Box>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <CalendarTodayIcon fontSize="small" />
              <Typography>
                የፈርጀ ዘመን: {selectedDenomination?.founded_year}
              </Typography>
            </Box>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <CalendarTodayIcon fontSize="small" />
              <Typography>
                ክልል የተመሠረተበት ዓ.ም: {selectedDenomination?.founded_month}
              </Typography>
            </Box>
          </Box>
        </Grid>
      </Grid>
    </Stack>
  );
};
